import React from 'react';
import PageLayout from 'components/layouts/PageLayout';
import Box from 'components/layouts/Box';
import KeyboardAltOutlinedIcon from '@mui/icons-material/KeyboardAltOutlined';
import WifiPasswordOutlinedIcon from '@mui/icons-material/WifiPasswordOutlined';
import Text from 'components/commons/Text';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { Row } from 'saladsoft-primitive';
import { IconButton } from '@mui/material';

const CheckinMethodPage = () => {
  return (
    <PageLayout title="체크인 방법">
      <Box type="clean" style={{ padding: 40 }}>
        <Row justifyContent="space-between" alignItems="center" gap={20}>
          <Row gap={20}>
            <KeyboardAltOutlinedIcon style={{ fontSize: '3rem' }} />
            <Text type="H2" style={{}}>
              키패드
            </Text>
          </Row>
          <IconButton style={{ border: 'none', backgroundColor: '#efefef' }}>
            <EditOutlinedIcon />
          </IconButton>
        </Row>
        <div style={{ borderBottom: '1px solid #cccccc', padding: 20 }} />
        <Row justifyContent="flex-start" alignItems="center" gap={20} marginTop={20}>
          <Text buttonRole="DESCRIPTION">하녹운, 서촌스테이, 문향재, 아름재</Text>
        </Row>
      </Box>
      <Box type="clean" style={{ padding: 40, marginTop: 20 }}>
        <Row justifyContent="space-between" alignItems="center" gap={20}>
          <Row gap={20}>
            <WifiPasswordOutlinedIcon style={{ fontSize: '3rem' }} />
            <Text type="H2" style={{}}>
              자동 도어록
            </Text>
          </Row>
          <IconButton style={{ border: 'none', backgroundColor: '#efefef' }}>
            <EditOutlinedIcon />
          </IconButton>
        </Row>
        <div style={{ borderBottom: '1px solid #cccccc', padding: 20 }} />
        <Row justifyContent="flex-start" alignItems="center" gap={20} marginTop={20}>
          <Text buttonRole="DESCRIPTION">예린당, 다인당, 환의당, 누월재</Text>
        </Row>
      </Box>
    </PageLayout>
  );
};
{
  /*
const IconButton = styled.div`
  border: 1px solid #cccccc;
  border-radius: 100px;
  padding: 20px;
  display: inline-block;
`; */
}

export default CheckinMethodPage;
